import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const activityStyles = {
    activityList: {
        position: 'relative',
        '& .delete-form': {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            zIndex: '1000',
            '& .MuiCircularProgress-root': {
                position: 'absolute',
                top: '20px',
                left: '50%',
                zIndex: '1000',
                transform: 'translate(-50%, -50%)',
                '& + form': {
                    opacity: '0.9',
                    cursor: 'not-allowed',
                    pointerEvents: 'none',
                },
            },
            '& .notification-box': {
                margin: '12px',
                padding: '12px',
                maxWidth: 'calc(100% - 24px)',
                '& .notification-icon': {
                    marginRight: '8px',
                    '& svg': {
                        width: '24px',
                        height: '24px',
                    },
                },
                '& .MuiTypography-root': {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '12px',
                    letterSpacing: '-0.14px',
                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                        display: 'block',
                    },
                    '& .notification-buttons': {
                        [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                            width: '100%',
                            justifyContent: 'center',
                            marginTop: '12px',
                        },
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '12px',
                        whiteSpace: 'nowrap',
                        '& .MuiButton-root': {
                            borderRadius: '8px',
                            padding: '6px 12px',
                            fontSize: '11px',
                            lineHeight: '16px',
                            letterSpacing: '-0.11px',
                        },
                    },
                },
            },
        },
        '& .activity-list-item': {
            display: 'block',
            boxSizing: 'border-box',
            borderRadius: '20px 20px 20px 2px',
            padding: '24px',
            backgroundColor: Palette.gray.gray100,
            color: Palette.black,
            width: '100%',
            marginBottom: '12px',
            position: 'relative',
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                marginBottom: '8px',
            },
            '&--hidden': {
                backgroundColor: Palette.red.red50,
            },
            '&--yellow': {
                backgroundColor: Palette.yellow.yellow50,
            },
            '&.opacity-20': {
                opacity: '0.2',
            },
            '&:hover': {
                '& .action-buttons': {
                    display: 'flex',
                },
            },
            '& .action-buttons': {
                position: 'absolute',
                top: '12px',
                right: '12px',
                display: 'none',
                gap: '4px',
                backgroundColor: Palette.white,
                borderRadius: '12px',
                boxShadow: Palette.boxShadow.elevation3,
                padding: '4px',
                '& .MuiButtonBase-root': {
                    padding: '8px',
                },
                '&[data-visible="true"]': {
                    display: 'flex',
                },
            },
            '& .details': {
                display: 'block',
                marginBottom: '20px',
                width: '100%',
                '& .details-content': {
                    fontSize: '14px',
                    fontWeight: 400,
                    lineHeight: '20px',
                    letterSpacing: '-0.14px',
                    color: Palette.black,
                },
                '& .status-pill-container': {
                    marginTop: '8px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '4px',
                },
                '& .status-pill': {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '4px 6px',
                    borderRadius: '6px',
                    backgroundColor: Palette.white,
                    fontSize: '11px',
                    '& svg': {
                        width: '16px',
                        height: '16px',
                    },
                },
                '& .status-pill--previous': {
                    color: Palette.gray.gray500,
                    '& svg': {
                        color: Palette.gray.gray500,
                    },
                    '& svg path, & svg circle': {
                        fill: Palette.white,
                    },
                },
                '& .status-pill--added': {
                    backgroundColor: Palette.green.green100,
                },
                '& .status-pill--removed': {
                    backgroundColor: Palette.red.red100,
                },
            },
            '& .footer': {
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '11px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '16px',
                letterSpacing: '-0.11px',
                color: Palette.gray.gray600,
                '& .MuiTypography-caption': {
                    fontSize: '11px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '16px',
                    letterSpacing: '-0.11px',
                    color: Palette.gray.gray600,
                },
                '& .footer-source': {
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                },
                '& .footer-visibility': {
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '8px',
                    textAlign: 'right',
                    marginRight: '20px',
                },
                '& .footer-date': {
                    paddingTop: '4px',
                },
            },
        },
    },
    activityLoadMore: {
        '& .activity-list-load-more': {
            display: 'flex',
            justifyContent: 'center',
            marginTop: '32px',
            '& .MuiButton-root': {
                fontSize: '11px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '16px',
                letterSpacing: '-0.11px',
                color: Palette.black,
                padding: '6px 6px 6px 16px',
                borderRadius: '10px',
                '& .MuiButton-endIcon': {
                    position: 'relative',
                    left: '-4px',
                    top: '-2px',
                    width: '16px',
                    height: '16px',
                },
                '& + .MuiButton-root': {
                    marginLeft: '8px',
                },
            },
        },
    },
    commentVisibilityBox: {
        position: 'relative',
        top: '14px',
        margin: '0 14px -40px 0',
        zIndex: '2',
        width: 'max-content',
        float: 'right',
    },
    richTextInputWrapper: {
        width: 'calc(100% - 4px)',
        paddingTop: '2px',
        margin: 'auto',
        position: 'relative',
        '& .service-request-rich-text-input': {
            '& .RaRichTextInput-editorContent .tiptap': {
                minHeight: '254px',
            },
            '& button[title="Strikethrough"]': {
                display: 'none',
            },
            '& button[title="Code"]': {
                display: 'none',
            },
            '& .MuiFormHelperText-root': {
                display: 'block',
            },
            '& .MuiToggleButtonGroup-root:nth-of-type(1)': {
                position: 'absolute',
                bottom: 48,
                left: 24,
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    bottom: 94,
                },
            },
            '& .MuiToggleButtonGroup-root:nth-of-type(2)': {
                position: 'absolute',
                bottom: 48,
                left: 156,
                [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                    bottom: 48,
                    left: 24,
                },
            },
            '& .MuiFormHelperText-root.Mui-error': {
                marginBottom: '10px',
            },
        },
    },
};
